import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // If no specific role is required, just check if user is authenticated
  if (!requiredRole) {
    return children;
  }

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const userRole = payload.role;

    // Check if user has the required role
    if (userRole === requiredRole || userRole === 'admin') {
      return children;
    } else {
      // Redirect to home page if user doesn't have required role
      return <Navigate to="/" replace />;
    }
  } catch (error) {
    console.error('Error parsing token:', error);
    return <Navigate to="/login" replace />;
  }
};

export default ProtectedRoute;

